import { object, string, mixed } from "yup";

export let schema = (t) =>
  object({
    bannerName: string()
      .required(t("validation:required-field"))
      .trim()
      .min(2, t("", { min: 2 }))
      .max(100, t("", { max: 100 })),
    
    bannerImage: mixed()
      .required(t("validation:required-field"))
      .test("fileSize", t("", { size: "2MB" }), (value) => {
        if (!value) return false;
        if (typeof value === "string") return true;
        return value && value.size <= 2 * 1024 * 1024; 
      })
      .test("fileType", "Invalid format. Please try again." ,(value) => {
        if (!value) return false;
        if (typeof value === "string") return true; 
        return value && ["image/jpeg", "image/jpg", "image/png"].includes(value.type);
      }),
    
    videoLink: string()
      .nullable()
      .notRequired()
      .test("is-valid-url", "Invalid URL. Please enter a valid YouTube link.", (value) => {
        if (!value || value.trim() === "") return true; 
        try {
          new URL(value);
          return true;
        } catch {
          return false;
        }
      })
      .trim(),
  });